import { createContext } from 'react';
export const AlertGroupContext = createContext({
    hasAnimations: false,
    updateTransitionEnd: () => { }
});
//# sourceMappingURL=AlertGroupContext.js.map